import { render, staticRenderFns } from "./Tariffication.vue?vue&type=template&id=1b16bb9f&"
import script from "./Tariffication.vue?vue&type=script&lang=ts&"
export * from "./Tariffication.vue?vue&type=script&lang=ts&"
import style0 from "./Tariffication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports